<template>
  <div class="wraper">
    <h2 class="breadCrumb">
      <span> 贴息申请 > </span>
      <span v-if="discountParams.id" class="active"> 编辑申请 </span>
      <span v-else class="active"> 添加申请 </span>
    </h2>
    <div class="clear" style="">
      <div class="nav-left fl" id="nav">
        <v-menu></v-menu>
      </div>
      <div class="content-box-right fr" id="content">
        <div class="modules-box">
          <div class="add-discount">
            <div class="fill-info">
              <div class="discount-title">
                <h5>信息填报</h5>
                <span
                  >（信息填报每次仅支持一次贷款填报，如企业多次贷款申请贴息，请分别申报）</span
                >
              </div>
              <div class="addDiscount-modules1">
                <p>
                  <label>企业名称<em>*</em></label
                  ><el-input
                    v-model="formData[5].value"
                    @blur="inputBlur(formData[5])"
                    placeholder="请输入企业名称"
                    style="width: 310px"
                  >
                  </el-input>
                  <span class="errMsg">{{ formData[5].msg }}</span>
                </p>
                <p>
                  <label>法人代表<em>*</em></label
                  ><el-input
                    v-model="formData[6].value"
                    @blur="inputBlur(formData[6])"
                    placeholder="请输入法人代表"
                    style="width: 310px"
                  >
                  </el-input>
                  <span class="errMsg">{{ formData[6].msg }}</span>
                </p>
                <p>
                  <label>统一社会信用代码<em>*</em></label
                  ><el-input
                    v-model="addDiscount.creditCode"
                    placeholder="请输入统一社会信用代码"
                    style="width: 310px"
                  >
                  </el-input>
                  <!-- <span class="errMsg">{{formData[6].msg}}</span> -->
                </p>
                <p>
                  <label>经办人电话<em>*</em></label
                  ><el-input
                    v-model="formData[7].value"
                    @blur="inputBlur(formData[7])"
                    placeholder="请输入经办人电话"
                    style="width: 310px"
                  >
                  </el-input>
                  <span class="errMsg">{{ formData[7].msg }}</span>
                </p>
                <!-- <p>
                                    <label>联系人<em>*</em></label
                                    ><el-input
                                        v-model="formData[6].value"
                                        @blur="inputBlur(formData[6])"
                                        placeholder="请输入联系人"
                                        style="width: 310px"
                                    >
                                    </el-input>
                                    <span class="errMsg">{{formData[6].msg}}</span>
                                </p> -->
                <!-- <p>
                                    <label>联系方式<em>*</em></label
                                    ><el-input
                                        v-model="formData[7].value"
                                        @blur="inputBlur(formData[7])"
                                        placeholder="请输入联系方式"
                                        style="width: 310px"
                                    >
                                    </el-input>
                                    <span class="errMsg">{{formData[7].msg}}</span>
                                </p> -->
                <!-- <p>
                                    <label>选择政策<em>*</em></label>
                                    <el-select
                                        v-model="addDiscount.policyName"
                                        @change="policyChanged"
                                        placeholder="请选择政策"
                                        style="width: 310px"
                                    >
                                        <el-option
                                            v-for="item in policyList"
                                            :key="item.value"
                                            :label="item.policyName"
                                            :value="item.policyId"
                                        >
                                        </el-option>
                                    </el-select>
                                    <span class="errMsg">{{policyMsg}}</span>
                                </p>
                                <p>
                                    <label>选择所属旗区<em>*</em></label>
                                    <el-select
                                        v-model="addDiscount.area"
                                        placeholder="请选择所属旗区"
                                        style="width: 310px"
                                    >
                                        <el-option
                                            v-for="item in areaList"
                                            :key="item.value"
                                            :label="item.areaName"
                                            :value="item.areaCode"
                                        >
                                        </el-option>
                                    </el-select>
                                    <span class="errMsg">{{areaMsg}}</span>
                                </p> -->
                <p>
                  <label>2022年营业收入<em>*</em></label
                  ><el-input
                    v-model="addDiscount.income"
                    placeholder="请输入金额"
                    style="width: 310px"
                  >
                    <i slot="suffix">元</i></el-input
                  >
                  <!-- <span class="errMsg">{{formData[0].msg}}</span> -->
                </p>
                <p>
                  <label>2022年末企业人数(以社保登记为准)<em>*</em></label
                  ><el-input
                    v-model="addDiscount.personNum"
                    placeholder="请输入人数"
                    style="width: 310px"
                  >
                    <i slot="suffix">人</i></el-input
                  >
                  <!-- <span class="errMsg">{{formData[0].msg}}</span> -->
                  <span clasw></span>
                </p>
                <p>
                  <label>所属行业<em>*</em></label>
                  <el-select
                    v-model="addDiscount.industry"
                    @change="policyChanged"
                    placeholder="请选择行业"
                    style="width: 310px"
                  >
                    <el-option
                      v-for="item in industryList"
                      :key="item.itemCode"
                      :label="item.itemName"
                      :value="item.itemCode"
                    >
                    </el-option>
                  </el-select>
                  <!-- <span class="errMsg">{{formData[1].msg}}</span> -->
                </p>
                <p>
                  <label>企业地址<em>*</em></label
                  ><el-input
                    v-model="addDiscount.entAddress"
                    placeholder="请输入地址"
                    style="width: 310px"
                  >
                  </el-input>
                  <!-- <span class="errMsg">{{formData[1].msg}}</span> -->
                </p>
                <p>
                  <label>区域筛选<em>*</em></label>
                  <el-select
                    v-model="addDiscount.area"
                    placeholder="请选择区域"
                    style="width: 310px"
                  >
                    <el-option
                      v-for="item in areaList"
                      :key="item.itemCode"
                      :label="item.itemName"
                      :value="item.itemCode"
                    >
                    </el-option>
                  </el-select>
                </p>
                <p>
                  <label>主要业务范围<em>*</em></label
                  ><el-input
                    v-model="addDiscount.entScope"
                    placeholder="请输入业务范围"
                    style="width: 310px"
                  >
                  </el-input>
                </p>
                <p>
                  <label>贷款银行<em>*</em></label
                  ><el-input
                    maxlength="64"
                    v-model="formData[1].value"
                    @blur="inputBlur(formData[1])"
                    placeholder="请输入贷款银行"
                    style="width: 310px"
                  >
                  </el-input>
                  <span class="errMsg">{{ formData[1].msg }}</span>
                </p>
                <p>
                  <label>贷款金额<em>*</em></label
                  ><el-input
                    v-model="formData[0].value"
                    @blur="inputBlur(formData[0])"
                    placeholder="请输入贷款金额"
                    style="width: 310px"
                  >
                    <i slot="suffix">元</i></el-input
                  >
                  <span class="errMsg">{{ formData[0].msg }}</span>
                </p>
                <!-- <p>
                                    <label>贷款起止日<em>*</em></label>
                                    <el-date-picker
                                        style="width: 310px"
                                        @change="selectTime"
                                        value-format="yyyy-MM-dd"
                                        v-model="value1"
                                        type="daterange"
                                        unlink-panels
                                        range-separator="-"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期"
                                    >
                                    </el-date-picker>
                                    <span class="errMsg">{{loanTimeMsg}}</span>
                                </p> -->
                <p>
                  <label>贷款起止日<em>*</em></label>
                  <el-date-picker
                    style="width: 145px"
                    v-model="startValue"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="开始日期"
                    @focus="startFocus"
                    @change="selectStartTime"
                  >
                  </el-date-picker>
                  -
                  <el-date-picker
                    style="width: 145px"
                    v-model="endValue"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="结束日期"
                    @change="selectEndTime"
                    :picker-options="datePickerOptionsEnd"
                  >
                  </el-date-picker>
                  <span class="errMsg">{{ loanTimeMsg }}</span>
                </p>

                <p>
                  <label>申请贴息金额<em>*</em></label
                  ><el-input
                    v-model="formData[2].value"
                    @blur="inputBlur(formData[2])"
                    placeholder="请输入申请贴息金额"
                    style="width: 310px"
                  >
                    <i slot="suffix">元</i>
                  </el-input>
                  <span class="errMsg">{{ formData[2].msg }}</span>
                </p>
                <p>
                  <label>贷款总额<em>*</em></label
                  ><el-input
                    v-model="addDiscount.sumAmount"
                    placeholder="请输入贷款总额"
                    style="width: 310px"
                  >
                    <i slot="suffix">元</i>
                  </el-input>
                  <!-- <span class="errMsg">{{formData[2].msg}}</span> -->
                </p>
                <p>
                  <label>补发发放银行开户行<em>*</em></label
                  ><el-input
                    v-model="formData[3].value"
                    @blur="inputBlur(formData[3])"
                    placeholder="请输入补贴发放银行开户行"
                    style="width: 310px"
                  >
                  </el-input>
                  <span class="errMsg">{{ formData[3].msg }}</span>
                </p>
                <p>
                  <label>补发发放银行账号<em>*</em></label
                  ><el-input
                    v-model="formData[4].value"
                    @blur="inputBlur(formData[4])"
                    placeholder="请输入补贴发放银行账号"
                    style="width: 310px"
                  >
                  </el-input>
                  <span class="errMsg">{{ formData[4].msg }}</span>
                </p>
                <p>
                  <label>生产经营受新冠肺炎影响情况说明<em>*</em></label
                  ><el-input
                    v-model="addDiscount.xinguan"
                    placeholder="请输入说明"
                    style="width: 310px"
                  >
                  </el-input>
                  <!-- <span class="errMsg">{{formData[4].msg}}</span> -->
                </p>
              </div>
            </div>
            <div class="files-upload">
              <div class="discount-title">
                <h5>材料上传</h5>
                <span>（仅支持PDF文件格式）</span>
              </div>
              <div class="addDiscount-modules1">
                <div class="file-item">
                  <p>1.贷款贴息申请表<i>*</i></p>
                  <el-upload
                    class="upload-demo"
                    ref="discountApply"
                    :limit="1"
                    :http-request="uploadDiscountApplyFn"
                    :on-remove="removeDiscountApplyUrlFile"
                    :on-success="uploadSuccess"
                    :on-exceed="exceedLimit"
                    accept=".pdf"
                    action="https://jsonplaceholder.typicode.com/posts/"
                  >
                    <el-button size="small"
                      ><i class="el-icon-upload"></i>上传文件</el-button
                    >
                  </el-upload>
                  <div class="isEdit" v-if="isDiscountApplyUrl">
                    <a
                      :href="addDiscount.discountApplyUrl"
                      :download="addDiscount.discountApplyUrl"
                      >贷款贴息申请表.pdf</a
                    >
                  </div>
                </div>
                <div class="file-item">
                  <p>2.企业统一社会信用代码证<i>*</i></p>
                  <el-upload
                    class="upload-demo"
                    ref="creditCode"
                    :limit="1"
                    :http-request="uploadCreditCodeFn"
                    :on-remove="removeCreditCodeFile"
                    :on-success="uploadSuccess"
                    :on-exceed="exceedLimit"
                    accept=".pdf"
                    action="https://jsonplaceholder.typicode.com/posts/"
                  >
                    <el-button size="small"
                      ><i class="el-icon-upload"></i>上传文件</el-button
                    >
                  </el-upload>
                  <div class="isEdit" v-if="isCreditCodeUrl">
                    <a
                      :href="addDiscount.creditCodeUrl"
                      :download="addDiscount.creditCodeUrl"
                      >企业统一社会信用代码证.pdf</a
                    >
                  </div>
                </div>
                <!-- <div class="file-item">
                                    <p>3.复工复产证明材料<i>*</i></p>
                                    <p class="tips">说明：2020年3月20日前复工复产的企业，提供行业主管部门提供的复工复产证明，2020年3月20日后复工复产的企业，提交能证明企业已经复工复产的其他材料，并加盖企业公章</p>
                                    <el-upload
                                        class="upload-demo"
                                        ref="resumeProve"

                                        :limit="1"
                                        :http-request="uploadResumeProveFn"
                                        :on-remove="removeResumeProveFile"
                                        :on-success="uploadSuccess"
                                        :on-exceed="exceedLimit"
                                        accept=".pdf"
                                        action="https://jsonplaceholder.typicode.com/posts/"
                                    >
                                        <el-button
                                            size="small"
                                            ><i class="el-icon-upload"></i>上传文件</el-button
                                        >

                                    </el-upload>
                                    <div class="isEdit" v-if="isResumeProveUrl">
                                        <a :href="addDiscount.resumeProveUrl" :download="addDiscount.resumeProveUrl">复工复产证明材料.pdf</a>
                                    </div>
                                </div> -->
                <div class="file-item">
                  <p>3.银行借款合同<i>*</i></p>
                  <el-upload
                    class="upload-demo"
                    ref="bankLoan"
                    :limit="1"
                    :http-request="uploadBankLoanFn"
                    :on-remove="removeBankLoanFile"
                    :on-success="uploadSuccess"
                    :on-exceed="exceedLimit"
                    accept=".pdf"
                    action="https://jsonplaceholder.typicode.com/posts/"
                  >
                    <el-button size="small"
                      ><i class="el-icon-upload"></i>上传文件</el-button
                    >
                  </el-upload>
                  <div class="isEdit" v-if="isBankLoanUrl">
                    <a
                      :href="addDiscount.bankLoanUrl"
                      :download="addDiscount.bankLoanUrl"
                      >银行借款合同.pdf</a
                    >
                  </div>
                </div>
                <div class="file-item">
                  <p>4.利息结算清单<i>*</i></p>
                  <el-upload
                    class="upload-demo"
                    ref="interestSettle"
                    :limit="1"
                    :http-request="uploadInterestSettleFn"
                    :on-remove="removeInterestSettleFile"
                    :on-success="uploadSuccess"
                    :on-exceed="exceedLimit"
                    accept=".pdf"
                    action="https://jsonplaceholder.typicode.com/posts/"
                  >
                    <el-button size="small"
                      ><i class="el-icon-upload"></i>上传文件</el-button
                    >
                  </el-upload>
                  <div class="isEdit" v-if="isInterestSettleUrl">
                    <a
                      :href="addDiscount.interestSettleUrl"
                      :download="addDiscount.interestSettleUrl"
                      >利息结算清单.pdf</a
                    >
                  </div>
                </div>
                <!-- <div class="file-item">
                                    <p>6.食品经营许可证<i>*</i></p>
                                    <el-upload
                                        class="upload-demo"
                                        ref="foodBusiness"

                                        :limit="1"
                                        :http-request="
                                            uploadFoodBusinessFn
                                        "
                                        :on-remove="removeFoodBusinessFile"
                                        :on-success="uploadSuccess"
                                        :on-exceed="exceedLimit"
                                        accept=".pdf"
                                        action="https://jsonplaceholder.typicode.com/posts/"
                                    >
                                        <el-button
                                            size="small"
                                            ><i class="el-icon-upload"></i>上传文件</el-button
                                        >
                                    </el-upload>
                                    <div class="isEdit" v-if="isFoodBusinessUrl">
                                        <a :href="addDiscount.foodBusinessUrl" :download="addDiscount.foodBusinessUrl">贷款到账凭证.pdf</a>
                                    </div>
                                </div> -->
                <!-- <div class="file-item">
                                    <p>7.贷款到账凭证<i>*</i></p>
                                    <el-upload
                                        class="upload-demo"
                                        ref="loanCertificate"

                                        :limit="1"
                                        :http-request="
                                            uploadLoanCertificateFn
                                        "
                                        :on-remove="removeLoanCertificateFile"
                                        :on-success="uploadSuccess"
                                        :on-exceed="exceedLimit"
                                        accept=".pdf"
                                        action="https://jsonplaceholder.typicode.com/posts/"
                                    >
                                        <el-button
                                            size="small"
                                            ><i class="el-icon-upload"></i>上传文件</el-button
                                        >
                                    </el-upload>
                                    <div class="isEdit" v-if="isLoanCertificateUrl">
                                        <a :href="addDiscount.loanCertificateUrl" :download="addDiscount.loanCertificateUrl">贷款到账凭证.pdf</a>
                                    </div>
                                </div> -->
              </div>
            </div>
          </div>
          <div class="apply-btn">
            <button class="info-lan" @click="storageBtn">暂存</button>
            <button class="lan-btn" @click="submitBtn">立即提交</button>
          </div>
        </div>
      </div>
    </div>
    <!-- 二次确认弹窗 -->
    <Popup
      :show.sync="show"
      :title="title"
      className="popup-delete"
      v-show="show"
    >
      <div slot="popup-content">
        <div class="popup-content-sure"><i></i>确认提交吗？</div>
      </div>
      <div slot="popup-footer" class="popup-btn">
        <a
          href="javaScript:;"
          class="popup-cancel popup-cancel1"
          @click="cancelHandle"
          >取消</a
        >
        <a href="javaScript:;" class="popup-sure" @click="sureHandle">确定</a>
      </div>
    </Popup>
  </div>
</template>
<script>
import vMenu from "@/common/sideBar/index.vue"; //侧边栏
import Popup from "@/components/popup/index.vue";
import { dataSource } from "@/api/api";
import { checkout } from "@/assets/js/checkout";
import { debounce } from "@/assets/js/util";
export default {
  props: {},
  name: "discountDetail",
  components: {
    //注册组件
    vMenu, //侧边栏
    Popup
  },
  data() {
    return {
      startValue: "", // 贷款起止日-开始日期
      endValue: "", // 贷款起止日-结束日期
      datePickerOptions: {
        // 贷款起止日-开始日期为2020-01-01到2020-12-31
        disabledDate: (time) => {
          let start2020 = new Date("2019-12-31").getTime();
          let end2020 = new Date("2020-12-31").getTime();
          return time.getTime() <= start2020 || time.getTime() > end2020; //注意是||不是&&
        }
      },
      datePickerOptionsEnd: {
        // 贷款起止日-结束日期 应大于开始日期
        disabledDate: (time) => {
          let start2020 = new Date("2019-12-31").getTime();
          if (this.startValue) {
            let selectData = new Date(this.startValue).getTime();
            return (
              time.getTime() < start2020 ||
              time.getTime() < selectData /*结束日期要在选择的开始日期之后*/
            );
          }
          return time.getTime() <= start2020; /*2020-01-01之后*/
        }
      },
      show: false,
      title: "提交申请",
      formData: [
        // 校验数据
        {
          id: "1",
          name: "贷款金额",
          type: "numFloat",
          decimal: "2",
          value: "",
          required: true,
          msg: "",
          info: "贷款金额必须为数字,长度不能大于15位且支持两位小数"
        },
        {
          id: "2",
          name: "贷款银行",
          type: "chinese",
          value: "",
          required: true,
          msg: "",
          info: "贷款银行为汉字且长度不能大于64位"
        },
        {
          id: "3",
          name: "申请贴息金额",
          type: "numFloat",
          decimal: "2",
          value: "",
          required: true,
          msg: "",
          info: "贴息金额必须为数字,长度不能大于15位且支持两位小数"
        },
        {
          id: "4",
          name: "补贴发放银行开户行",
          type: "chinese",
          value: "",
          required: true,
          msg: "",
          info: "补贴发放银行开户行为汉字且长度不能大于64位"
        },
        {
          id: "6",
          name: "补贴发放银行账号",
          type: "bankAccount",
          value: "",
          required: true,
          msg: "",
          info: "补贴发放银行账号为数字且长度不能大于64位"
        },
        {
          id: "7",
          name: "企业名称",
          type: "chinese",
          value: "",
          required: true,
          msg: "",
          info: "企业名称为汉字且长度不能大于64位"
        },
        {
          id: "8",
          name: "法人代表",
          type: "",
          value: "",
          required: false,
          msg: "",
          info: ""
        },
        {
          id: "9",
          name: "经办人电话",
          type: "phone",
          value: "",
          required: true,
          msg: "",
          info: "手机号格式不对"
        }
      ],
      policyList: [], // 政策列表
      // areaList: [],// 区域列表
      // 行业列表
      industryList: [
        {
          itemName: "居民和家庭服务",
          itemCode: "居民和家庭服务"
        },
        {
          itemName: "健康服务",
          itemCode: "健康服务"
        },
        {
          itemName: "养老服务",
          itemCode: "养老服务"
        },
        {
          itemName: "旅游游览和娱乐服务",
          itemCode: "旅游游览和娱乐服务"
        },
        {
          itemName: "体育服务",
          itemCode: "体育服务"
        },
        {
          itemName: "文化服务",
          itemCode: "文化服务"
        },
        {
          itemName: "居民零售和互联网销售服务",
          itemCode: "居民零售和互联网销售服务"
        },
        {
          itemName: "居民出行服务",
          itemCode: "居民出行服务"
        },
        {
          itemName: "住宿餐饮服务",
          itemCode: "住宿餐饮服务"
        },
        {
          itemName: "教育培训服务",
          itemCode: "教育培训服务"
        },
        {
          itemName: "居民住房服务",
          itemCode: "居民住房服务"
        },
        {
          itemName: "其他生活性服务",
          itemCode: "其他生活性服务"
        }
      ],
      areaList: [
        {
          itemCode: "50010000",
          itemName: "鄂尔多斯市"
        },
        {
          itemCode: "50010001",
          itemName: "东胜区"
        },
        {
          itemCode: "50010002",
          itemName: "康巴什区"
        },
        {
          itemCode: "50010003",
          itemName: "准格尔旗"
        },
        {
          itemCode: "50010004",
          itemName: "伊金霍洛旗"
        },
        {
          itemCode: "50010005",
          itemName: "鄂托克旗"
        },
        {
          itemCode: "50010006",
          itemName: "鄂托克前旗"
        },
        {
          itemCode: "50010007",
          itemName: "杭锦旗"
        },
        {
          itemCode: "50010008",
          itemName: "达拉特旗"
        },
        {
          itemCode: "50010009",
          itemName: "乌审旗"
        },
        {
          itemCode: "50010010",
          itemName: "空港园区"
        },
        {
          itemCode: "50010011",
          itemName: "鄂尔多斯高新技术产业园区"
        },
        {
          itemCode: "50010012",
          itemName: "其他"
        }
      ],
      addDiscount: {
        // 新增时参数
        applyAmount: 0,
        // applyNo: "",
        area: "",
        bankLoanUrl: "",
        creditCodeUrl: "",
        discountAccountOpenBank: "",
        discountApplyUrl: "",
        discountIssueAccount: "",
        // entName: "",
        // id: 0,
        interestSettleUrl: "",
        loanAmount: 0,
        loanBank: "",
        loanEndTime: "",
        loanStartTime: "",
        policyId: "",
        policyName: "",
        resumeProveUrl: "",
        foodBusinessUrl: "",
        loanCertificateUrl: "",
        status: "",
        userId: "",

        entName: "",
        contactName: "",
        contactPhone: "",
        creditCode: "",

        personNum: "",
        income: "",
        industry: "",
        entAddress: "",
        entScope: "",
        sumAmount: "",
        xinguan: ""
      },
      updateDiscount: {
        // 修改时参数
        id: null,
        policyId: "",
        policyName: "",
        area: "",
        loanAmount: 0,
        applyAmount: 0,
        discountAccountOpenBank: "",
        loanBank: "",
        loanEndTime: "",
        loanStartTime: "",
        discountIssueAccount: "",
        discountApplyUrl: "",
        creditCodeUrl: "",
        resumeProveUrl: "",
        bankLoanUrl: "",
        interestSettleUrl: "",
        foodBusinessUrl: "",
        loanCertificateUrl: "",
        status: "",

        entName: "",
        contactName: "",
        contactPhone: ""
      },
      //value1: "", // 日期
      uploadFileMsg: "",
      discountParams: {}, // 贴息session
      isDiscountApplyUrl: false,
      isCreditCodeUrl: false,
      isResumeProveUrl: false,
      isBankLoanUrl: false,
      isInterestSettleUrl: false,
      isFoodBusinessUrl: false,
      isLoanCertificateUrl: false,
      isFinish: true,
      policyMsg: "",
      areaMsg: "",
      loanTimeMsg: ""
    };
  },
  computed: {},
  methods: {
    startFocus() {
      this.startValue = "2020-01-01";
      this.addDiscount.loanStartTime = "2020-01-01";
    },
    inputBlur(item) {
      // 校验

      checkout.otherCheckout(item);
      if (item.msg) {
        // this.$message.error(item.msg);
        this.isFinish = false;
        return false;
      }
    },

    // selectTime(val) { // 贷款起止日期
    //     this.addDiscount.loanStartTime = val[0];
    //     this.addDiscount.loanEndTime = val[1];
    // },
    selectStartTime(val) {
      // 贷款起止日期
      this.addDiscount.loanStartTime = val;
    },
    selectEndTime(val) {
      // 贷款起止日期
      this.addDiscount.loanEndTime = val;
    },
    policyChanged(val) {
      // 选择政策
      this.policyList.map((item) => {
        if (val == item.policyId) {
          this.addDiscount.policyId = val;
          this.addDiscount.policyName = item.policyName;
        }
      });
    },

    exceedLimit(files, fileList) {
      // 文件超出限制
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件,如需上传其它文件，请先删除不需要的文件。`
      );
    },

    uploadSuccess(response, file, fileList) {
      // this.$refs.upload.clearFiles();
    },

    removeDiscountApplyUrlFile() {
      // 删除贷款贴息申请表文件
      this.addDiscount.discountApplyUrl = "";
    },
    removeCreditCodeFile() {
      // 删除统一社会信用代码证文件
      this.addDiscount.creditCodeUrl = "";
    },
    removeResumeProveFile() {
      // 删除复工复产证明材料
      this.addDiscount.resumeProveUrl = "";
    },
    removeBankLoanFile() {
      // 删除银行借款合同
      this.addDiscount.bankLoanUrl = "";
    },
    removeInterestSettleFile() {
      // 删除利息结算清单
      this.addDiscount.interestSettleUrl = "";
    },
    removeFoodBusinessFile() {
      // 删除食品经营许可证
      this.addDiscount.foodBusinessUrl = "";
    },
    removeLoanCertificateFile() {
      // 删除贷款到账凭证
      this.addDiscount.loanCertificate = "";
    },
    uploadDiscountApplyFn(params) {
      // 贷款贴息申请表文件
      const file = params.file;
      if (file && file.size > 15 * 1024 * 1024) {
        this.$message.error("选择文件大于15M,请重新选择");
        this.$refs.discountApply.clearFiles();
        return;
      }
      if (file && file.type != "application/pdf") {
        this.$message.error("仅支持PDF文件格式,请重新选择");
        this.$refs.discountApply.clearFiles();
        return;
      }
      let formData = new FormData();
      formData.append("file", file);
      dataSource.uploadDiscountApply(formData).then((res) => {
        // console.log(res);
        this.isDiscountApplyUrl = false;
        if (res.data.code === 1) {
          this.uploadFileMsg = res.data.data;
          this.$message.success("贷款贴息申请表上传成功！");
          this.addDiscount.discountApplyUrl = res.data.data.url;
        } else {
          this.$refs.discountApply.clearFiles();
          this.$message.error(res.data.msg);
        }
      });
    },

    uploadCreditCodeFn(params) {
      // 统一社会信用代码证文件
      const file = params.file;
      if (file && file.size > 15 * 1024 * 1024) {
        this.$message.error("选择文件大于15M,请重新选择");
        this.$refs.creditCode.clearFiles();
        return;
      }
      if (file && file.type != "application/pdf") {
        this.$message.error("仅支持PDF文件格式,请重新选择");
        this.$refs.creditCode.clearFiles();
        return;
      }
      let formData = new FormData();
      formData.append("file", file);
      dataSource.uploadDiscountApply(formData).then((res) => {
        this.isCreditCodeUrl = false;
        if (res.data.code === 1) {
          this.uploadFileMsg = res.data.data;
          this.addDiscount.creditCodeUrl = res.data.data.url;
          this.$message.success("统一社会信用代码证上传成功！");
        } else {
          this.$refs.creditCode.clearFiles();
          this.$message.error(res.data.msg);
        }
      });
    },

    uploadResumeProveFn(params) {
      // 复工复产证明材料
      const file = params.file;
      if (file && file.size > 15 * 1024 * 1024) {
        this.$message.error("选择文件大于15M,请重新选择");
        this.$refs.resumeProve.clearFiles();
        return;
      }
      if (file && file.type != "application/pdf") {
        this.$message.error("仅支持PDF文件格式,请重新选择");
        this.$refs.resumeProve.clearFiles();
        return;
      }
      let formData = new FormData();
      formData.append("file", file);
      dataSource.uploadResumeProve(formData).then((res) => {
        this.isResumeProveUrl = false;
        if (res.data.code === 1) {
          this.uploadFileMsg = res.data.data;
          this.addDiscount.resumeProveUrl = res.data.data.url;
          this.$message.success("复工复产证明材料上传成功！");
        } else {
          this.$refs.resumeProve.clearFiles();
          this.$message.error(res.data.msg);
        }
      });
    },

    uploadBankLoanFn(params) {
      // 银行借款合同
      const file = params.file;
      if (file && file.size > 15 * 1024 * 1024) {
        this.$message.error("选择文件大于15M,请重新选择");
        this.$refs.bankLoan.clearFiles();
        return;
      }
      if (file && file.type != "application/pdf") {
        this.$message.error("仅支持PDF文件格式,请重新选择");
        this.$refs.bankLoan.clearFiles();
        return;
      }
      let formData = new FormData();
      formData.append("file", file);
      dataSource.uploadBankLoan(formData).then((res) => {
        this.isBankLoanUrl = false;
        if (res.data.code === 1) {
          this.uploadFileMsg = res.data.data;
          this.addDiscount.bankLoanUrl = res.data.data.url;
          this.$message.success("银行借款合同上传成功！");
        } else {
          this.$refs.bankLoan.clearFiles();
          this.$message.error(res.data.msg);
        }
      });
    },

    uploadInterestSettleFn(params) {
      // 上传利息结算清单
      const file = params.file;
      if (file && file.size > 15 * 1024 * 1024) {
        this.$message.error("选择文件大于15M,请重新选择");
        this.$refs.interestSettle.clearFiles();
        return;
      }
      if (file && file.type != "application/pdf") {
        this.$message.error("仅支持PDF文件格式,请重新选择");
        this.$refs.interestSettle.clearFiles();
        return;
      }
      let formData = new FormData();
      formData.append("file", file);
      dataSource.uploadInterestSettle(formData).then((res) => {
        this.isInterestSettleUrl = false;
        if (res.data.code === 1) {
          this.uploadFileMsg = res.data.data;
          this.addDiscount.interestSettleUrl = res.data.data.url;
          this.$message.success("利息结算清单上传成功！");
        } else {
          this.$refs.interestSettle.clearFiles();
          this.$message.error(res.data.msg);
        }
      });
    },
    uploadFoodBusinessFn(params) {
      // 食品经营许可证
      const file = params.file;
      if (file && file.size > 15 * 1024 * 1024) {
        this.$message.error("选择文件大于15M,请重新选择");
        this.$refs.foodBusiness.clearFiles();
        return;
      }
      if (file && file.type != "application/pdf") {
        this.$message.error("仅支持PDF文件格式,请重新选择");
        this.$refs.foodBusiness.clearFiles();
        return;
      }
      let formData = new FormData();
      formData.append("file", file);
      dataSource.uploadFoodBusiness(formData).then((res) => {
        this.isFoodBusinessUrl = false;
        if (res.data.code === 1) {
          this.uploadFileMsg = res.data.data;
          this.addDiscount.foodBusinessUrl = res.data.data.url;
          this.$message.success("食品经营许可证上传成功！");
        } else {
          this.$refs.foodBusiness.clearFiles();
          this.$message.error(res.data.msg);
        }
      });
    },

    uploadLoanCertificateFn(params) {
      // 贷款到账凭证
      const file = params.file;
      if (file && file.size > 15 * 1024 * 1024) {
        this.$message.error("选择文件大于15M,请重新选择");
        this.$refs.loanCertificate.clearFiles();
        return;
      }
      if (file && file.type != "application/pdf") {
        this.$message.error("仅支持PDF文件格式,请重新选择");
        this.$refs.loanCertificate.clearFiles();
        return;
      }
      let formData = new FormData();
      formData.append("file", file);
      dataSource.uploadLoanCertificate(formData).then((res) => {
        this.isLoanCertificateUrl = false;
        if (res.data.code === 1) {
          this.uploadFileMsg = res.data.data;
          this.addDiscount.loanCertificateUrl = res.data.data.url;
          this.$message.success("贷款到账凭证上传成功！");
        } else {
          this.$refs.loanCertificate.clearFiles();
          this.$message.error(res.data.msg);
        }
      });
    },

    postDiscountAreaListFn() {
      // 区域列表
      dataSource
        .postDiscountAreaList()
        .then((res) => {
          if (res.data.code === 1) {
            let data = res.data.data;
            this.areaList = data;
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    postDiscountPolicyListFn() {
      // 政策列表
      dataSource
        .postDiscountPolicyList()
        .then((res) => {
          if (res.data.code === 1) {
            let data = res.data.data;
            this.policyList = data;
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    storageBtn() {
      // 暂存
      this.addDiscount.status = "70040001";
      this.addDiscount.userId = localStorage.getItem("entId");
      this.addDiscount.loanAmount = this.formData[0].value;
      this.addDiscount.loanBank = this.formData[1].value;

      this.addDiscount.applyAmount = this.formData[2].value;
      this.addDiscount.discountAccountOpenBank = this.formData[3].value;
      this.addDiscount.discountIssueAccount = this.formData[4].value;

      this.addDiscount.entName = this.formData[5].value;
      this.addDiscount.contactName = this.formData[6].value;
      this.addDiscount.contactPhone = this.formData[7].value;
      let b = true;
      // if (this.addDiscount.entName == "") {
      //     b = false;
      //     this.$message.error("请输入企业名称");
      //     return;
      // }
      // if (this.addDiscount.contactName == "") {
      //     b = false;
      //     this.$message.error("请输入法人代表");
      //     return;
      // }
      // if (this.addDiscount.credit_code == "") {
      //     b = false;
      //     this.$message.error("请输入统一社会信用代码");
      //     return;
      // }
      if (this.addDiscount.contactPhone == "") {
        b = false;
        this.$message.error("请输入经办人电话");
        return;
      }

      if (this.addDiscount.income == "") {
        b = false;
        this.$message.error("请输入2022年营业收入");
        return;
      }
      if (this.addDiscount.personNum == "") {
        b = false;
        this.$message.error("请输入2022年末企业人数");
        return;
      }
      if (this.addDiscount.industry == "") {
        b = false;
        this.$message.error("请输入所属行业");
        return;
      }
      if (this.addDiscount.entAddress == "") {
        b = false;
        this.$message.error("请输入企业地址");
        return;
      }
      if (this.addDiscount.area == "") {
        b = false;
        this.$message.error("请选择区域");
        return;
      }
      if (this.addDiscount.entScope == "") {
        b = false;
        this.$message.error("请输入主要业务范围");
        return;
      }

      // if (this.addDiscount.policyName == "") {
      //     b = false;
      //     this.$message.error("请选择政策");
      //     return;
      // }
      // if (this.addDiscount.area == "") {
      //     b = false;
      //     this.$message.error("请选择所属旗区");
      //     return;
      // }
      if (this.addDiscount.loanAmount == "") {
        b = false;
        this.$message.error("请输入贷款金额");
        return;
      }
      if (this.addDiscount.loanBank == "") {
        b = false;
        this.$message.error("请输入贷款银行");
        return;
      }
      if (this.addDiscount.loanStartTime == "") {
        b = false;
        this.$message.error("请输入开始日期");
        return;
      }
      if (this.addDiscount.loanEndTime == "") {
        b = false;
        this.$message.error("请输入结束日期");
        return;
      }
      if (this.addDiscount.applyAmount == "") {
        b = false;
        this.$message.error("请输入申请贴息金额");
        return;
      }
      if (this.addDiscount.sumAmount == "") {
        b = false;
        this.$message.error("请输入贷款总额");
        return;
      }
      if (this.addDiscount.discountAccountOpenBank == "") {
        b = false;
        this.$message.error("请输入补贴发放银行开户行");
        return;
      }
      if (this.addDiscount.discountIssueAccount == "") {
        b = false;
        this.$message.error("请输入补贴发放银行账号");
        return;
      }
      if (this.addDiscount.xinguan == "") {
        b = false;
        this.$message.error("请输入生产经营受新冠肺炎影响情况说明");
        return;
      }

      if (!this.addDiscount.discountApplyUrl) {
        b = false;
        this.$message.error("请先上传贷款贴息申请表！");
        return;
      }
      if (!this.addDiscount.creditCodeUrl) {
        b = false;
        this.$message.error("请先上传统一社会信用代码证！");
        return;
      }
      // if (!this.addDiscount.resumeProveUrl) {
      //     b = false;
      //     this.$message.error("请先上传复工复产证明材料！");
      //     return;
      // }
      if (!this.addDiscount.bankLoanUrl) {
        b = false;
        this.$message.error("请先上传银行借款合同！");
        return;
      }
      if (!this.addDiscount.interestSettleUrl) {
        b = false;
        this.$message.error("请先上传利息结算清单！");
        return;
      }
      // if (!this.addDiscount.foodBusinessUrl) {
      //     b = false;
      //     this.$message.error("请先上传食品经营许可证！");
      //     return;
      // }
      // if (!this.addDiscount.loanCertificateUrl) {
      //     b = false;
      //     this.$message.error("请先上传贷款到账凭证！");
      //     return;
      // }
      this.formData.map((item) => {
        checkout.otherCheckout(item);
        if (item.msg) {
          // this.$message.error(item.msg);
          this.isFinish = false;
          return false;
        }
      });

      if (
        this.formData[0].msg == "" &&
        this.formData[1].msg == "" &&
        this.formData[2].msg == "" &&
        this.formData[3].msg == "" &&
        this.formData[4].msg == "" &&
        this.formData[5].msg == "" &&
        this.formData[6].msg == "" &&
        this.formData[7].msg == ""
      ) {
        this.isFinish = true;
      }
      if (!this.isFinish) {
        this.$message.error("填写信息有误，请修改后提交！");
      }
      if (b && this.isFinish) {
        if (this.discountParams.id) {
          //id存在是编辑
          this.debounceUpdateDiscountFn();
        } else {
          //不存在是新增
          this.debounceAddDiscountFn();
        }
      }
    },

    submitBtn() {
      // 提交

      console.log("提交");
      this.addDiscount.status = "70040002";
      this.addDiscount.userId = localStorage.getItem("entId");
      this.addDiscount.loanAmount = this.formData[0].value;
      this.addDiscount.loanBank = this.formData[1].value;

      this.addDiscount.applyAmount = this.formData[2].value;
      this.addDiscount.discountAccountOpenBank = this.formData[3].value;
      this.addDiscount.discountIssueAccount = this.formData[4].value;

      this.addDiscount.entName = this.formData[5].value;
      this.addDiscount.contactName = this.formData[6].value;
      this.addDiscount.contactPhone = this.formData[7].value;
      console.log(this.addDiscount);
      let b = true;
      if (this.addDiscount.entName == "") {
        b = false;
        this.$message.error("请输入企业名称");
        return;
      }
      if (this.addDiscount.contactName == "") {
        b = false;
        this.$message.error("请输入法人代表");
        return;
      }
      if (this.addDiscount.creditCode == "") {
        b = false;
        this.$message.error("请输入统一社会信用代码");
        return;
      }
      if (this.addDiscount.contactPhone == "") {
        b = false;
        this.$message.error("请输入经办人电话");
        return;
      }

      if (this.addDiscount.income == "") {
        b = false;
        this.$message.error("请输入2022年营业收入");
        return;
      }
      if (this.addDiscount.personNum == "") {
        b = false;
        this.$message.error("请输入2022年末企业人数");
        return;
      }
      if (this.addDiscount.industry == "") {
        b = false;
        this.$message.error("请输入所属行业");
        return;
      }
      if (this.addDiscount.entAddress == "") {
        b = false;
        this.$message.error("请输入企业地址");
        return;
      }
      if (this.addDiscount.area == "") {
        b = false;
        this.$message.error("请选择区域");
        return;
      }
      if (this.addDiscount.entScope == "") {
        b = false;
        this.$message.error("请输入主要业务范围");
        return;
      }

      // if (this.addDiscount.policyName == "") {
      //     b = false;
      //     this.$message.error("请选择政策");
      //     return;
      // }
      // if (this.addDiscount.area == "") {
      //     b = false;
      //     this.$message.error("请选择所属旗区");
      //     return;
      // }
      if (this.addDiscount.loanAmount == "") {
        b = false;
        this.$message.error("请输入贷款金额");
        return;
      }
      if (this.addDiscount.loanBank == "") {
        b = false;
        this.$message.error("请输入贷款银行");
        return;
      }
      if (this.addDiscount.loanStartTime == "") {
        b = false;
        this.$message.error("请输入开始日期");
        return;
      }
      if (this.addDiscount.loanEndTime == "") {
        b = false;
        this.$message.error("请输入结束日期");
        return;
      }
      if (this.addDiscount.applyAmount == "") {
        b = false;
        this.$message.error("请输入申请贴息金额");
        return;
      }
      if (this.addDiscount.sumAmount == "") {
        b = false;
        this.$message.error("请输入贷款总额");
        return;
      }
      if (this.addDiscount.discountAccountOpenBank == "") {
        b = false;
        this.$message.error("请输入补贴发放银行开户行");
        return;
      }
      if (this.addDiscount.discountIssueAccount == "") {
        b = false;
        this.$message.error("请输入补贴发放银行账号");
        return;
      }
      if (this.addDiscount.xinguan == "") {
        b = false;
        this.$message.error("请输入生产经营受新冠肺炎影响情况说明");
        return;
      }
      if (!this.addDiscount.discountApplyUrl) {
        b = false;
        this.$message.error("请先上传贷款贴息申请表！");
        return;
      }
      if (!this.addDiscount.creditCodeUrl) {
        b = false;
        this.$message.error("请先上传统一社会信用代码证！");
        return;
      }
      // if (!this.addDiscount.resumeProveUrl) {
      //     b = false;
      //     this.$message.error("请先上传复工复产证明材料！");
      //     return;
      // }
      if (!this.addDiscount.bankLoanUrl) {
        b = false;
        this.$message.error("请先上传银行借款合同！");
        return;
      }
      if (!this.addDiscount.interestSettleUrl) {
        b = false;
        this.$message.error("请先上传利息结算清单！");
        return;
      }
      // if (!this.addDiscount.foodBusinessUrl) {
      //     b = false;
      //     this.$message.error("请先上传食品经营许可证！");
      //     return;
      // }
      // if (!this.addDiscount.loanCertificateUrl) {
      //     b = false;
      //     this.$message.error("请先上传贷款到账凭证！");
      //     return;
      // }
      this.formData.map((item) => {
        checkout.otherCheckout(item);
        if (item.msg) {
          // this.$message.error(item.msg);
          this.isFinish = false;
          return false;
        }
        if (
          this.formData[0].msg == "" &&
          this.formData[1].msg == "" &&
          this.formData[2].msg == "" &&
          this.formData[3].msg == "" &&
          this.formData[4].msg == "" &&
          this.formData[5].msg == "" &&
          this.formData[7].msg == ""
        ) {
          this.isFinish = true;
        }
      });
      if (!this.isFinish) {
        this.$message.error("填写信息有误，请修改后提交！");
        return;
      }
      if (b && this.isFinish) {
        this.show = true;
      }
    },

    cancelHandle() {
      // 取消提交
      this.show = false;
    },
    sureHandle() {
      // 确认提交
      //console.log(this.addDiscount)
      if (this.discountParams.id) {
        //id存在是编辑
        this.debounceUpdateDiscountFn();
      } else {
        //不存在是新增
        this.debounceAddDiscountFn();
      }
    },
    // 有id是编辑，无id是新增
    addDiscountFn() {
      // 新增申请
      dataSource
        .addDiscount({
          area: this.addDiscount.area,
          userId: Number(this.addDiscount.userId),
          entName: this.addDiscount.entName,
          contactName: this.addDiscount.contactName,
          creditCode: this.addDiscount.creditCode,
          contactPhone: this.addDiscount.contactPhone,
          income: Number(this.addDiscount.income),
          personNum: Number(this.addDiscount.personNum),
          industry: this.addDiscount.industry,
          entAddress: this.addDiscount.entAddress,
          entScope: this.addDiscount.entScope,
          loanBank: this.addDiscount.loanBank,
          loanAmount: Number(this.addDiscount.loanAmount),
          applyAmount: Number(this.addDiscount.applyAmount),
          sumAmount: Number(this.addDiscount.sumAmount),
          discountAccountOpenBank: this.addDiscount.discountAccountOpenBank,
          discountIssueAccount: this.addDiscount.discountIssueAccount,
          xinguan: this.addDiscount.xinguan,
          loanStartTime: this.addDiscount.loanStartTime,
          loanEndTime: this.addDiscount.loanEndTime,

          policyId: this.$route.query.id,
          policyName: this.$route.query.name,
          discountApplyUrl: this.addDiscount.discountApplyUrl,
          creditCodeUrl: this.addDiscount.creditCodeUrl,
          bankLoanUrl: this.addDiscount.bankLoanUrl,
          interestSettleUrl: this.addDiscount.interestSettleUrl,
          status: this.addDiscount.status
        })
        .then((res) => {
          if (res.data.code === 1) {
            this.show = false;
            this.$router.push({
              name: "applyDiscount"
            });
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    updateDiscountFn() {
      // 编辑申请
      this.updateDiscount.id = this.discountParams.id;

      this.updateDiscount.income = this.addDiscount.income;
      this.updateDiscount.personNum = this.addDiscount.personNum;
      this.updateDiscount.industry = this.addDiscount.industry;
      this.updateDiscount.entAddress = this.addDiscount.entAddress;
      this.updateDiscount.entScope = this.addDiscount.entScope;
      this.updateDiscount.sumAmount = this.addDiscount.sumAmount;
      this.updateDiscount.xinguan = this.addDiscount.xinguan;

      this.updateDiscount.policyId = this.addDiscount.policyId;
      this.updateDiscount.policyName = this.addDiscount.policyName;
      this.updateDiscount.area = this.addDiscount.area;
      this.updateDiscount.loanAmount = this.addDiscount.loanAmount;
      this.updateDiscount.applyAmount = this.addDiscount.applyAmount;
      this.updateDiscount.discountAccountOpenBank =
        this.addDiscount.discountAccountOpenBank;
      this.updateDiscount.loanBank = this.addDiscount.loanBank;
      this.updateDiscount.loanStartTime = this.addDiscount.loanStartTime;
      this.updateDiscount.loanEndTime = this.addDiscount.loanEndTime;
      this.updateDiscount.discountIssueAccount =
        this.addDiscount.discountIssueAccount;
      this.updateDiscount.discountApplyUrl = this.addDiscount.discountApplyUrl;
      this.updateDiscount.creditCodeUrl = this.addDiscount.creditCodeUrl;
      this.updateDiscount.resumeProveUrl = this.addDiscount.resumeProveUrl;
      this.updateDiscount.bankLoanUrl = this.addDiscount.bankLoanUrl;
      this.updateDiscount.interestSettleUrl =
        this.addDiscount.interestSettleUrl;
      this.updateDiscount.foodBusinessUrl = this.addDiscount.foodBusinessUrl;
      this.updateDiscount.loanCertificateUrl =
        this.addDiscount.loanCertificateUrl;
      this.updateDiscount.status = this.addDiscount.status;

      this.updateDiscount.entName = this.formData[5].value;
      this.updateDiscount.contactName = this.formData[6].value;
      this.updateDiscount.contactPhone = this.formData[7].value;
      dataSource
        .updateDiscount(this.updateDiscount)
        .then((res) => {
          if (res.data.code === 1) {
            this.show = false;
            this.$router.push({
              name: "applyDiscount"
            });
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    discountDetailFn() {
      // 编辑时渲染数据
      dataSource
        .discountDetail({ id: this.discountParams.id })
        .then((res) => {
          if (res.data.code === 1) {
            let data = res.data.data;
            data.loanStartTime = data.loanStartTime.substring(0, 10);
            data.loanEndTime = data.loanEndTime.substring(0, 10);
            this.addDiscount.policyName = data.policyName;
            this.addDiscount.policyId = data.policyId;
            this.policyList.map((item) => {
              if (data.policyName == item.policyName) {
                this.addDiscount.policyId = item.policyId;
                this.updateDiscount.policyId = item.policyId;
              }
            });
            this.addDiscount.area = data.area;
            this.formData[0].value = data.loanAmount;
            this.formData[1].value = data.loanBank;
            this.formData[2].value = data.applyAmount;
            this.formData[3].value = data.discountAccountOpenBank;
            this.formData[4].value = data.discountIssueAccount;
            this.formData[5].value = data.entName;
            this.formData[6].value = data.contactName;
            this.formData[7].value = data.contactPhone;
            //this.value1 = [ data.loanStartTime, data.loanEndTime];
            this.startValue = data.loanStartTime;
            this.endValue = data.loanEndTime;

            this.addDiscount.income = data.income;
            this.addDiscount.personNum = data.personNum;
            this.addDiscount.industry = data.industry; // 所属行业
            this.addDiscount.entAddress = data.entAddress;
            this.addDiscount.entScope = data.entScope;
            this.addDiscount.sumAmount = data.sumAmount;
            this.addDiscount.xinguan = data.xinguan;

            this.addDiscount.loanStartTime = data.loanStartTime;
            this.addDiscount.loanEndTime = data.loanEndTime;
            this.addDiscount.discountApplyUrl = data.discountApplyUrl;
            this.addDiscount.creditCodeUrl = data.creditCodeUrl;
            this.addDiscount.resumeProveUrl = data.resumeProveUrl;
            this.addDiscount.bankLoanUrl = data.bankLoanUrl;
            this.addDiscount.interestSettleUrl = data.interestSettleUrl;
            this.addDiscount.foodBusinessUrl = data.foodBusinessUrl;
            this.addDiscount.loanCertificateUrl = data.loanCertificateUrl;
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    getContactPersonFn() {
      dataSource
        .getContactPerson({ userId: localStorage.getItem("entId") })
        .then((res) => {
          if (res.data.code === 1) {
            let data = res.data.data;
            this.formData[5].value = data.entName;
            this.formData[6].value = data.contactName;
            this.addDiscount.creditCode = data.creditCode;
            // this.formData[7].value = data.contactPhone;
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    }
  },
  created() {
    // console.log(this.$route.query.id)
    // console.log(this.$route.query.name)
    this.debounceUpdateDiscountFn = debounce(this.updateDiscountFn, 500, true);
    this.debounceAddDiscountFn = debounce(this.addDiscountFn, 500, true);
    // this.postDiscountAreaListFn(); // 获取区域列表
    this.postDiscountPolicyListFn(); // 获取政策列表
    this.getContactPersonFn(); //获取联系人信息
  },
  mounted() {
    this.discountParams = JSON.parse(sessionStorage.getItem("discountParams"));
    if (this.discountParams.id) {
      // id存在是编辑
      this.isDiscountApplyUrl = true;
      this.isCreditCodeUrl = true;
      this.isResumeProveUrl = true;
      this.isBankLoanUrl = true;
      this.isInterestSettleUrl = true;
      this.isFoodBusinessUrl = true;
      this.isLoanCertificateUrl = true;
      this.discountDetailFn();
    } else {
      // id不存在是新增
      this.isDiscountApplyUrl = false;
      this.isCreditCodeUrl = false;
      this.isResumeProveUrl = false;
      this.isBankLoanUrl = false;
      this.isInterestSettleUrl = false;
      this.isFoodBusinessUrl = false;
      this.isLoanCertificateUrl = false;
    }
  }
};
</script>
<style lang="less" scoped>
@url: "../../../assets/images/";
.add-discount {
  background: #fff;
  padding: 25px 0 0 0;
  .addDiscount-modules1 {
    margin-left: 24px;
    margin-top: 20px;
    margin-right: 20px;
    p {
      margin-bottom: 20px;
      label {
        display: inline-block;
        width: 270px;
        text-align: right;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #000000;
        line-height: 22px;
        em {
          color: red;
          margin-right: 5px;
        }
      }
      .errMsg {
        color: red;
        font-size: 12px;
        margin-left: 5px;
      }
    }
    .file-item {
      padding: 20px;
      border-bottom: 1px dashed #e9e9e9;
      &:last-child {
        border: none;
      }
      p {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.85);
        line-height: 24px;
        i {
          color: red;
        }
      }
      p.tips {
        color: #999;
        font-size: 12px;
      }
      .isEdit {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #0a6dd9;
        line-height: 22px;
        margin-top: 20px;
        a {
          color: #0a6dd9;
        }
        a:link {
          color: #0a6dd9;
        }
        a:visited {
          color: #0a6dd9;
        }
        a:hover {
          color: #0a6dd9;
        }
        a:active {
          color: #0a6dd9;
        }
      }
    }
  }
}
.apply-btn {
  display: flex;
  margin: 24px 0;
  & > button {
    width: 160px;
    height: 48px;
    border-radius: 2px;
    margin-right: 24px;
  }
  & > button.info-lan {
    background: #ffffff;
    border: 1px solid #1566fb;
  }
  & > button.lan-btn {
    background: #2968da;
  }
}
.popup-content-sure {
  width: 100%;
  text-align: center;
  height: 80px;
  line-height: 80px;
  i {
    display: inline-block;
    width: 16px;
    height: 16px;
    background: url("@{url}icon/icon-info-orange.png") no-repeat;
    background-size: 100% 100%;
    margin-right: 6px;
    position: relative;
    top: 2px;
  }
}
</style>
